import { ClubAdmin } from '@features/club/ui/ClubAdmin';
import { ClubAdminFormWidget } from '@features/club/ui/ClubAdminForm';
import { ClubAdminManagersWidget } from '@features/club/ui/ClubAdminManagers';

type Props = {
  clubId: string;
};

export function ClubAdminWidget({ clubId }: Props) {
  return (
    <ClubAdmin
      details={<ClubAdminFormWidget clubId={clubId} />}
      managers={<ClubAdminManagersWidget clubId={clubId} />}
    />
  );
}
